import { useState, useEffect } from 'react';
import { Button, Space, App } from 'antd';
import { ProTable } from '@ant-design/pro-components';
import { theme } from 'antd';
import { disputeOverviewTableColumns } from './DisputeOverviewTableColumns';
import { 
    useGetAllCustomerUidQuery,
    useGetLogisticsServiceByNameQuery,
    useGetCostExceptionDisputeQuery,
    useCostExceptionDisputeBulkOperationBySelectMutation,
    useCostExceptionDisputeBulkOperationBySearchMutation,
 } from '../../features/api/apiSlice';
function DisputeOverviewTab() {
    const { token } = theme.useToken();
    const [searchData, setSearchData] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const { data, isLoading, isFetching } = useGetCostExceptionDisputeQuery(searchData);
    const { data: customerUidData, } = useGetAllCustomerUidQuery({}, {
        refetchOnMountOrArgChange: true,
    })
    const { data: logisticsService } = useGetLogisticsServiceByNameQuery({}, {
        refetchOnMountOrArgChange: true,
    });
    const columns = disputeOverviewTableColumns(customerUidData, logisticsService);
    const { notification } = App.useApp();
    const [downloadCostExceptionWithErrorDataWithSelect, {
        isLoading: isDownloading,
        isSuccess: isDownloadSuccess,
        isError: isDownloadError,
        error: downloadError,
    }] = useCostExceptionDisputeBulkOperationBySelectMutation();
    
    const [downloadCostExceptionWithErrorDataWithSearch, {
        isLoading: isDownloadingBySearch,
        isSuccess: isDownloadSuccessBySearch,
        isError: isDownloadErrorBySearch,
        error: downloadErrorBySearch,
    }] = useCostExceptionDisputeBulkOperationBySearchMutation();

    useEffect(() => {
        if (isDownloadSuccess) {
            notification.success({
                message: '下载成功',
                description: '下载成功,请前往后台任务管理获取文件',
            })
            setSelectedRowKeys([]);
        }
        if (isDownloadError) {
            console.error('Download error:', downloadError);
            notification.error({
                message: '下载失败',
                description: downloadError?.data?.error || '下载失败，请稍后重试',
            })
        }
    }, [isDownloadSuccess, isDownloadError, downloadError]);

    useEffect(() => {
        if (isDownloadSuccessBySearch) {
            notification.success({
                message: '下载成功',
                description: '下载成功,请前往后台任务管理获取文件',
            })
        }
        if (isDownloadErrorBySearch) {
            console.error('Download error:', downloadErrorBySearch);
            notification.error({
                message: '下载失败',
                description: downloadErrorBySearch?.data?.error || '下载失败，请稍后重试',
            })
        }
    }, [isDownloadSuccessBySearch, isDownloadErrorBySearch, downloadErrorBySearch]);

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
        },
        selectedRowKeys,
    }

    const downloadButtonHandler = () => {
        const formData = new FormData();
        formData.append('exception_ids', selectedRowKeys);
        formData.append('operation', 'download');
        downloadCostExceptionWithErrorDataWithSelect(formData);
    }

    const downloadButtonBySearchHandler = (searchConfig) => {
        searchConfig.form.validateFields().then((values) => {
            const request = {
                operation: "download",
                ...values,
            }
            downloadCostExceptionWithErrorDataWithSearch(request);
        })
    }

    return (
        <ProTable
            rowKey={(record) => record.id}
            search={{
                span: { xs: 24, sm: 12, md: 8, lg: 8, xl: 8, xxl: 8 },
                labelWidth: 'auto',
                defaultCollapsed: false,
                style: {
                    maxWidth: 'none',
                    background: token.colorFillAlter,
                    borderRadius: token.borderRadiusLG,
                    padding: 24,
                },
                optionRender: (searchConfig, formProps, dom) => [
                    <Button
                        key="downloadButton"
                        type="primary"
                        loading={isDownloadingBySearch}
                        onClick={() => downloadButtonBySearchHandler(searchConfig, formProps)}
                    >
                        下载数据
                    </Button>,
                    ...dom,
                ],
            }}
            columns={columns}
            request={(params) => {
                setSearchData(params);
            }}
            rowSelection={rowSelection}
            manualRequest={true}
            tableAlertOptionRender={() => {
                return (
                    <Space size='small'>
                        <Button type="link" loading={isDownloading} onClick={() => downloadButtonHandler()}>下载数据</Button>
                        <Button type="link" onClick={() => { setSelectedRowKeys([]) }}>取消选择</Button>
                    </Space>
                )
            }}
            loading={{
                spinning: isLoading || isFetching,
                tip: '数据加载中...',
            }}
            dataSource={data?.results}
            pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                total: data?.count,
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}

export default DisputeOverviewTab;